import {
  ItemFileType,
  StoreImage,
  StoreImageEnum,
  getStoreImageHeight,
  getStoreImageWidth,
} from '@systemeio/digital-store-shared'
import { FileSourceEnum } from '@systemeio/file-manager'
import debounce from 'lodash.debounce'
import { FC, useEffect, useState } from 'react'
import { ImageUploader } from 'shared/components/file-uploader/image-uploader'
import { DataFile } from 'shared/types/datafile-type'
import { CloseIcon, UploadIcon } from '@systemeio/ui'

interface StoreImageSelectorProps {
  imageType: StoreImageEnum
  dataFile: ItemFileType | null
  label: string
  onChange: (dataFile: DataFile | null) => void
}

const StoreImageSelector: FC<StoreImageSelectorProps> = ({
  onChange,
  dataFile,
  label,
  imageType,
}) => {
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    if (dataFile) {
      setDisabled(true)
    }
  }, [dataFile])

  const width = getStoreImageWidth(imageType)
  const height = getStoreImageHeight(imageType)

  return (
    <>
      <ImageUploader
        source={FileSourceEnum.DigitalStore}
        icon={<></>}
        label={''}
        labelClassName="hidden"
        imageCropperModalProps={{
          imageCropperProps: { aspectRatio: width / height },
        }}
        disabled={disabled}
        onSelect={dataFile => {
          onChange(dataFile)
          setDisabled(true)
        }}
      >
        <div
          className={
            'flex w-full flex-col items-center justify-center gap-3 sm:flex-row sm:justify-between'
          }
        >
          <div className={'relative [&>svg]:h-full [&>svg]:w-full'}>
            <StoreImage
              imageType={imageType}
              alt={dataFile?.name ?? imageType}
              className={'rounded-xl'}
              thumbnail={dataFile}
              skipTheme
            />
            {dataFile && (
              <button
                onClick={() => {
                  onChange(null)
                  debounce(() => setDisabled(false))()
                }}
                className={
                  'bg-brand-primary hover:bg-brand-primary-hover main-transition-colors pointer-events-auto absolute left-0 top-0 flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full p-1'
                }
              >
                <CloseIcon className={'fill-background-secondary h-4 w-4'} />
              </button>
            )}
          </div>
          <div className={'flex w-full flex-col items-center justify-center gap-1'}>
            <UploadIcon />
            {label}
          </div>
          <div />
        </div>
      </ImageUploader>
    </>
  )
}

export default StoreImageSelector
